module.exports = __webpack_public_path__ + "static/media/louis-hansel-C5YnAXEEZS0-unsplash.671791f6.jpg";